export interface Dropdown {
  value: string,
  displayValue: string
};

export const activeStatus: Dropdown[] = [
  {displayValue: 'Tous', value: 'all'},
  {displayValue: 'Oui', value: 'true'},
  {displayValue: 'Non', value: 'false'}
];

export const paymentWays: Dropdown[] = [
  {displayValue: 'Tous', value: 'all'},
  {displayValue: 'Ogone / Ingénico', value: 'ogone'},
  {displayValue: 'Stripe', value: 'stripe'},
  {displayValue: 'Chèque', value: 'check'},
  {displayValue: 'Mobile Android', value: 'android'},
  {displayValue: 'Mobile Apple', value: 'apple'}
];

export const periods: Dropdown[] = [
  {displayValue: 'Tous', value: 'all'},
  {displayValue: 'Annuelle', value: 'year'},
  {displayValue: 'Mensuelle', value: 'month'},
  {displayValue: 'Non reconductible', value: 'None'},
];

export const subscriptionTypes: Dropdown[] = [
  {displayValue: 'Tous', value: 'all'},
  {displayValue: 'Classique', value: 'AbonneClassique'},
  {displayValue: 'Legacy', value: 'AbonneLegacy'},
  {displayValue: 'Premium', value: 'AbonnePremium'},
  {displayValue: 'Etudiant', value: 'AbonneEtudiant'},
];

export interface FiltersInterface {
  role?: string,
  active?: string,
  paymentWay?: string,
  period?: string,
  userId__contains?: string
}